export const PANEL_ANIMATION_DURATION = 150;
export const panelTransitionStyles = {
  entered: { height: '80vh' },
  entering: { height: '60vh' },
  exited: { height: 0 },
  exiting: { height: '10vh' },
};
